/**
 * lead-capture.js
 * Submits the lead-magnet landing form to the App Proxy and redirects to the
 * thank-you page returned by the server.
 *
 * Consent model: there is no opt-in checkbox — submitting IS the consent. The
 * notice text visible at submit time is sent along and stored as the record of
 * what the person agreed to, so the copy on screen and the stored proof can
 * never drift apart.
 */

(function () {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function collectUtm() {
    var params = new URLSearchParams(window.location.search);
    var utm = {};
    UTM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) utm[key.replace('utm_', '')] = value;
    });
    return utm;
  }

  function showMessage(root, text, isError) {
    var box = root.querySelector('[data-lead-message]');
    if (!box) return;
    box.hidden = false;
    box.textContent = text;
    box.classList.toggle('is-error', !!isError);
    box.classList.toggle('is-success', !isError);
  }

  function trackPixel(root) {
    var event = root.dataset.pixelEvent;
    if (!event || typeof window.fbq !== 'function') return;
    try {
      window.fbq('track', event, { content_name: root.dataset.campaign });
    } catch (err) {
      // Never let a blocked pixel break the redirect.
      console.warn('[lead-capture] pixel', err);
    }
  }

  function init(root) {
    var form = root.querySelector('.lead-capture__form');
    if (!form) return;

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      var emailEl = form.querySelector('[name="email"]');
      var email = emailEl ? emailEl.value.trim() : '';
      if (!email || !emailEl.checkValidity()) {
        showMessage(root, root.dataset.errorEmail || 'Digite um e-mail válido.', true);
        if (emailEl) emailEl.focus();
        return;
      }

      var nameEl = form.querySelector('[name="first_name"]');
      var hpEl = form.querySelector('[name="hp"]');
      var noticeEl = root.querySelector('[data-consent-notice]');

      var payload = {
        campaign: root.dataset.campaign,
        email: email,
        first_name: nameEl ? nameEl.value.trim() : '',
        consent_text: noticeEl ? noticeEl.textContent.trim() : '',
        source_url: window.location.href,
        utm: collectUtm(),
        hp: hpEl ? hpEl.value : '',
      };

      var button = form.querySelector('.lead-capture__submit');
      var originalLabel = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = '…';
      }

      try {
        var response = await fetch(root.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        var data = await response.json().catch(function () { return {}; });

        if (!response.ok || !data.success) {
          var message = Array.isArray(data.errors) && data.errors.length
            ? data.errors.join(', ')
            : 'Não foi possível concluir seu cadastro. Tente novamente.';
          throw new Error(message);
        }

        trackPixel(root);

        if (data.redirect_url) {
          window.location.assign(data.redirect_url);
          return;
        }
        // No redirect configured — confirm in place rather than leaving the user hanging.
        showMessage(root, 'Pronto! Confira seu e-mail.', false);
        form.reset();
      } catch (err) {
        console.error('[lead-capture]', err);
        showMessage(root, err.message, true);
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-lead-capture]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
